import { keepPreviousData } from '@tanstack/react-query'

import { useQuery } from '@percent/utility'

import { useOrganisationProfileContext } from '../context/OrganisationProfileContext'
import { GetOrganisationProfilesParams } from '../types/organisationProfile.types'

export const useOrganisationProfiles = (
  params: GetOrganisationProfilesParams,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const { service } = useOrganisationProfileContext()

  return useQuery(
    ['organisationProfiles', params],
    service.getOrganisationProfiles,
    params,
    { enabled, shallowData: true, placeholderData: keepPreviousData }
  )
}
